// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1AKCg","addWidgetButton":"Header_addWidgetButton__1pFxz","dashboardTabs":"Header_dashboardTabs__1Sfgg","active":"Header_active__Km_fj"};